export const FETCH_KNOWLEDGE_CHECK_REQUEST = 'FETCH_KNOWLEDGE_CHECK_REQUEST';
export const FETCH_KNOWLEDGE_CHECK_SUCCESS = 'FETCH_KNOWLEDGE_CHECK_SUCCESS';
export const FETCH_KNOWLEDGE_CHECK_FAILURE = 'FETCH_KNOWLEDGE_CHECK_FAILURE';

export const HIDE_KNOWLEDGE_CHECKS = 'HIDE_KNOWLEDGE_CHECKS';

export const POST_KNOWLEDGE_CHECK_REQUEST = 'POST_KNOWLEDGE_CHECK_REQUEST';
export const POST_KNOWLEDGE_CHECK_SUCCESS = 'POST_KNOWLEDGE_CHECK_SUCCESS';
export const POST_KNOWLEDGE_CHECK_FAILURE = 'POST_KNOWLEDGE_CHECK_FAILURE';
